import {uploadImage} from "../mediaUploader";

export async function handleBrandResource(params) {
  let data = params.data;
  if (params.data.logo && params.data.logo.rawFile instanceof File) {
    data.logo = (await uploadImage(params.data.logo, false, data.project))['@id'];
  }
  return data;
}
